import axios from 'axios';

// Helper function to check if S3 bucket is configured
export const configureS3 = () => {
  const mealImagesBucket = process.env.REACT_APP_MEAL_IMAGES_BUCKET;
  const region = process.env.REACT_APP_AWS_REGION || 'us-east-1';

  if (!mealImagesBucket) {
    console.warn('Meal images bucket not configured');
  }
};

/**
 * Generate an image for a meal using DALL-E
 * @param mealTitle The title of the meal
 * @param ingredients List of main ingredients
 * @param mealId Unique identifier for the meal
 * @returns Promise with the mealId which is used for S3 image path
 */
export const generateMealImage = async (
  mealTitle: string, 
  ingredients: string[],
  mealId: string
): Promise<string> => {
  try {
    // Create a prompt for DALL-E
    const mainIngredients = ingredients.slice(0, 5).join(', ');
    const prompt = `A professional food photography style image of ${mealTitle} with ${mainIngredients}. High resolution, well-lit, on a clean neutral background. Photorealistic.`;
    
    // Call your Lambda function that handles DALL-E API
    const response = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}/prod/generateImage`,
      {
        prompt,
        mealId,
        size: "1024x1024"
      }
    );
    
    // The response should contain the S3 key where the image was stored
    if (response.data && response.data.success) {
      // Just return the mealId itself
      return mealId;
    } else {
      throw new Error('Failed to generate image: Invalid response format');
    }
  } catch (error) {
    console.error('Error generating meal image:', error);
    return '';
  }
};

/**
 * Get the URL for a meal image
 * @param mealId The ID of the meal
 * @returns The URL of the image
 */
export const getMealImageUrl = (mealId: string): string => {
  if (!mealId) return '';
  
  // If mealId is already a full URL, return it
  if (mealId.startsWith('http')) {
    return mealId;
  }
  
  const bucket = process.env.REACT_APP_MEAL_IMAGES_BUCKET || 'ainutrition-meal-images';
  const region = process.env.REACT_APP_AWS_REGION || 'eu-north-1';
  
  // If mealId already contains a path structure, use it as is
  if (mealId.includes('/')) {
    return `https://${bucket}.s3.${region}.amazonaws.com/${mealId}.png`;
  }
  
  // Otherwise, use the standard meals/mealId.png format
  return `https://${bucket}.s3.${region}.amazonaws.com/meals/${mealId}.png`;
}; 